import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import {
  AiScreeningResponseStatus,
  AiScreeningResult,
  AiScreeningsResponse,
} from '@core/ai-screening-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { OfferStatusIndicatorComponent } from '@core/offers-ui';
import {
  BadgeComponent,
  CollapsibleCardComponent,
  DividerComponent,
  HeadingComponent,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';
import { ScreeningOffer } from '@recruitee/ai-screening-types';
import { getScreeningSummaryData } from '@recruitee/ai-screening-util';

import { AiScreeningResultsListComponent } from '../ai-screening-results-list/ai-screening-results-list.component';
import { ScreeningResultIndicatorComponent } from '../screening-result-indicator/screening-result-indicator.component';

@Component({
  selector: 'rt-screening-result-card',
  templateUrl: './screening-result-card.component.html',
  styleUrl: './screening-result-card.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CollapsibleCardComponent,
    HeadingComponent,
    ScreeningResultIndicatorComponent,
    TranslatePipe,
    OfferStatusIndicatorComponent,
    DividerComponent,
    RtTooltip,
    TruncateComponent,
    AiScreeningResultsListComponent,
    BadgeComponent,
  ],
})
export class ScreeningResultCardComponent {
  public screening = input.required<AiScreeningsResponse>();
  public disableEdit = input(false);
  public offer = input<ScreeningOffer | null>();
  public initialCollapsed = input(true);
  public hasNewBadge = input(false);

  public edit = output<AiScreeningResult>();

  protected screeningSummaryData = computed(() =>
    getScreeningSummaryData(this.screening().results, this.screening().status),
  );
  protected forceCollapsed = computed(() =>
    (<AiScreeningResponseStatus[]>['failed', 'pending', 'in_progress']).includes(
      this.screeningSummaryData().screeningStatus,
    ),
  );
}
